<template>
  <section class="relative font-semibold text-black max-w-3xl">
    <form
      class="events-search"
      @submit.prevent
    >
      <span class="size-11 absolute inset-y-0 left-0 flex justify-center items-center">
        <FontAwesomeIcon
          :icon="faSearch"
          class="text-secondary text-xl"
        />
      </span>

      <input
        v-model="searchParams.search"
        v-on-click-outside="hideResults"
        class="search-input"
        placeholder="Search for event"
        @keyup.enter="$emit('search')"
        @focus="showSearchResults = true"
      >

      <AppButton
        class="btn btn-solid btn-secondary rounded-s-none rounded-e border-secondary hover:border-btn-hover border-2"
        @click="$emit('search')"
      >
        Search
      </AppButton>
    </form>

    <div
      v-if="showSearchResults && searchParams.search && searchResults && searchResults.length "
      class="absolute top-14 bg-white flex flex-col divide-y divide-secondary-subtle rounded border border-gray-200 shadow-sm w-full"
    >
      <template
        v-for="result in searchResults"
        :key="result.id"
      >
        <AppLink
          class="px-4 py-2 hover:bg-secondary-subtle"
          :to="{
            name: 'app_event_show',
            params: {slug: result.slug}}"
        >
          {{ result.name }}
        </AppLink>
      </template>
    </div>
  </section>
</template>

<script setup>

import { faSearch } from '@fortawesome/pro-solid-svg-icons';
import { AppButton, AppLink } from '@/components/app';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { vOnClickOutside } from '@vueuse/components';
import { ref } from 'vue';

defineProps({
  searchResults: {
    type: Array,
    default: () => [],
  },
});

defineEmits(['search']);

const showResults = ref(true);

const searchParams = defineModel('searchParams');
const showSearchResults = defineModel('showSearchResults');

const hideResults = () => {
  return showSearchResults.value = false;
};

</script>
